import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0064FF",
      d: "M8 .503a7.97 7.97 0 0 0-5.43 2.138 8.081 8.081 0 0 0-.851 10.893 8 8 0 0 0 5.03 2.966v-5.628H4.72V8.551h2.03V6.777c0-2.017 1.195-3.13 3.025-3.13q.9.01 1.79.152v1.978h-1.006c-.993 0-1.303.62-1.303 1.257v1.51h2.21l-.355 2.325H9.25v5.628a8 8 0 0 0 5.032-2.966 8.08 8.08 0 0 0-.851-10.893A7.97 7.97 0 0 0 8 .5z"
    }, null, -1)
  ])))
}
export default { render: render }